// extracted by mini-css-extract-plugin
export default {"Button":"style_Button__ZoQ9d","buttonStyle":"style_buttonStyle__ULFyh"};